// WARNING: If it is necessary to make polyfill (<= IE 10), the following libraries should be used.
// import '@formatjs/intl-numberformat/polyfill'
// import '@formatjs/intl-numberformat/locale-data/<locale>'

/**
 * Format currency based on sales policy config.
 * https://github.com/vtex-apps/format-currency/blob/master/react/formatCurrency.ts
 *
 * @param {Object} culture
 * @param {Number} value
 * @returns {String}
 */
export function getFormattedPrice(culture, value) {
  const formatter = new Intl.NumberFormat(culture.locale, {
    style: 'currency',
    currency: culture.currency,
  });

  return formatter.format(value);
}

export default {
  getFormattedPrice,
};
